module.exports = __webpack_public_path__ + "static/media/estado.92d831a6.svg";